import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';

@Component({
  selector: 'dashboard-access',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './dashboard-access.component.html',
  styleUrl: './dashboard-access.component.css'
})
export class DashboardAccessComponent {
  @ViewChild('grid') grid?: WcGridComponent;

  reload(): void {
    this.grid?.reload(1);
  }
}
